import { Pricebook, PricebookEntry } from '@nuso/quoting/types';
import * as _ from 'lodash';
import { usageTypeSorter, pricebookEntrySorter } from './pricebook-helpers';

export function pricebookUsageTypes(pricebook: Pricebook) {
  return _.chain(pricebook.pricebookEntries)
    .map('usageType')
    .uniq()
    .compact()
    .sortBy(usageTypeSorter())
    .value();
}

export function sortPricebookEntries(pricebookEntries: PricebookEntry[]): PricebookEntry[] {
  return _.sortBy(pricebookEntries, pricebookEntrySorter())
}
